import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-table-header-row',
  standalone: true,
  imports: [],
  templateUrl: './table-header-row.component.html',
  styleUrl: './table-header-row.component.scss'
})
export class TableHeaderRowComponent {}
